(() => {
  const root = document.getElementById('mda-adult-lp');
  if (!root || root.dataset.ready) return;
  root.dataset.ready = 'true';
  const $ = (id) => root.querySelector(`#${id}`);
  let products, works, patterns;
  try {
    products = JSON.parse(document.getElementById('mda-products-data').textContent);
    works = JSON.parse(document.getElementById('mda-works-data').textContent);
    patterns = JSON.parse(document.getElementById('mda-patterns-data').textContent);
  } catch (_) { return; }
  const esc = (s) => String(s ?? '').replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
  const resized = (src, width) => { try { const u = new URL(src, location.origin); u.searchParams.set('width', width); return u.href; } catch (_) { return src; } };
  const money = value => new Intl.NumberFormat('ja-JP', {style:'currency',currency:'JPY',maximumFractionDigits:0}).format(value / 100);
  const length = units => (units % 2 === 0 ? `${units / 2}m` : units === 1 ? '50cm' : `${units / 2}m`);
  const storeUrl = path => window.Shopify ? path : new URL(path, 'https://kijimaru.jp').href;
  const sewingPattern = w => patterns.find(p => w?.patternLink === p.url);
  const bySku = sku => products.flatMap(p => p.variants).find(v => v.sku === sku);
  const product = () => products.find(p => p.handle === state.handle);
  const hasPatternOptions = () => product().variants[0].options.length > 1;
  const getPattern = v => v.options.length > 1 ? v.options[0] : state.handle === '4520-be' ? '5mm' : '無地';
  const getColor = v => v.options[v.options.length - 1];
  const firstWork = works.find(w => w.id === 125) || works[0];
  const state = {handle:firstWork.handle, variant:bySku(firstWork.sku), work:firstWork, units:1};
  const add = $('mda-add');
  const units = $('mda-units');
  const variantInput = $('mda-variant-id');
  const form = $('mda-cart-form');
  const message = $('mda-message');
  const grid = $('mda-work-grid');

  function renderCards(filter = 'all') {
    const items = works.filter(w => filter === 'all' || w.category === filter);
    grid.innerHTML = items.map(w => {
      const v = bySku(w.sku);
      const pattern = sewingPattern(w);
      const fabric = w.handle === '4500' ? '無地' : w.handle === '4510' ? `ストライプ ${w.pattern}` : w.handle === '4520-be' ? `ベージュ染めギンガム ${w.pattern}` : `ギンガム ${w.pattern}`;
      return `<article class="mda-work-card"><button class="mda-work-photo${w.id === 125 ? ' mda-work-photo--skirt' : ''}" type="button" data-work-id="${w.id}" aria-label="${esc(w.name + 'の使用生地を選ぶ')}"><img src="${esc(resized(w.image,640))}" width="640" height="800" loading="lazy" decoding="async" alt="${esc(w.name+'／'+w.color)}"></button><div class="mda-work-info"><h3 class="mda-work-name">${esc(w.name)}</h3><p class="mda-work-color">${esc(fabric+'・'+w.color)}</p><button type="button" class="mda-work-select" data-work-id="${w.id}"><span>${v?.available ? 'この生地を選ぶ' : 'この色を確認する'}</span><span aria-hidden="true">↗</span></button>${pattern ? `<a class="mda-work-pattern-link" href="${esc(storeUrl(pattern.url))}">この作品の型紙を見る ↗</a>` : ''}</div></article>`;
    }).join('');
    if ($('mda-work-count')) $('mda-work-count').textContent = `${items.length}点の作品`;
    root.querySelectorAll('[data-filter]').forEach(btn => {
      const selected = btn.dataset.filter === filter;
      btn.setAttribute('aria-pressed', String(selected));
      btn.classList.toggle('is-active', selected);
    });
  }

  function updatePreview() {
    const w = state.work;
    const img = $('mda-selected-work');
    img.src = resized(w ? w.image : state.variant.image, 900);
    img.alt = w ? `${w.name}／${w.color}` : `${product().title} ${state.variant.title}`;
    img.classList.toggle('mda-image--skirt', w?.id === 125);
    img.closest('.mda-buy-preview-frame').classList.toggle('mda-buy-preview-frame--fabric', !w);
    $('mda-selected-caption').textContent = w ? `${w.name}${w.note ? '　'+w.note : ''}` : `${product().title}／${getColor(state.variant)}`;
    const swatch = $('mda-selected-swatch');
    swatch.src = resized(state.variant.image, 240);
    swatch.alt = `${product().title} ${state.variant.title}の生地写真`;
  }

  function updateSewingPattern() {
    const p = sewingPattern(state.work);
    const v = p?.variants?.[0];
    $('mda-pattern-cross-sell').hidden = !v;
    $('mda-pattern-message').textContent = '';
    $('mda-pattern-add').disabled = !v?.available;
    $('mda-pattern-variant-id').value = v?.id || '';
    if (!v) return;
    const url = storeUrl(p.url);
    $('mda-sewing-pattern-image').src = resized(v.image, 240);
    $('mda-sewing-pattern-image').alt = p.title;
    for (const id of ['mda-pattern-image-link','mda-sewing-pattern-link','mda-pattern-details']) $(id).href = url;
    $('mda-sewing-pattern-link').textContent = p.title;
    $('mda-sewing-pattern-price').textContent = `${money(v.price)}（税込）`;
    $('mda-pattern-add').textContent = v.available ? '型紙を1点カートに入れる' : '型紙は現在品切れです';
  }

  function updatePrice() {
    const v = state.variant;
    const n = Number(units.value);
    const valid = Number.isInteger(n) && n >= 1 && n <= 200;
    state.units = valid ? n : state.units;
    $('mda-quantity').value = valid ? String(n) : '';
    $('mda-length').textContent = valid ? length(n) : '長さを選んでください';
    $('mda-total').textContent = valid ? money(v.price * n) : '—';
    $('mda-unit-price').textContent = `${money(v.price)} / 50cm（税込）`;
    $('mda-minus').disabled = !valid || n <= 1;
    $('mda-plus').disabled = !valid || n >= 200;
    add.disabled = !v.available || !valid;
    add.textContent = v.available ? 'カートに入れる' : 'この色は現在品切れです';
    if (!valid) message.textContent = '数量は1以上の整数で入力してください。';
    else if (!v.available) message.textContent = '別の色を選ぶか、商品ページで再入荷の案内をご確認ください。';
    else message.textContent = '';
  }

  function syncSelection() {
    const p = product(), v = state.variant;
    variantInput.value = v.id;
    $('mda-product-title').textContent = p.title;
    $('mda-color-name').textContent = getColor(v);
    $('mda-product-link').href = `${window.Shopify ? p.url : new URL(p.url, 'https://kijimaru.jp').href}?variant=${v.id}`;
    $('mda-product-link').textContent = '生地の詳しい情報を見る';
    $('mda-pattern-field').hidden = !hasPatternOptions();
    root.querySelectorAll('[data-product]').forEach(btn => {
      const selected = btn.dataset.product === p.handle;
      btn.setAttribute('aria-pressed', String(selected));
      btn.classList.toggle('is-active', selected);
    });
    const patterns = [...new Set(p.variants.map(getPattern))];
    $('mda-pattern').innerHTML = patterns.map(pattern => `<option value="${esc(pattern)}">${esc(pattern)}</option>`).join('');
    $('mda-pattern').value = getPattern(v);
    const variants = p.variants.filter(other => getPattern(other) === getPattern(v));
    $('mda-color').innerHTML = variants.map(other => `<option value="${other.id}">${esc(getColor(other))}${other.available ? '' : '（品切れ）'}</option>`).join('');
    $('mda-color').value = String(v.id);
    updatePreview();
    updateSewingPattern();
    updatePrice();
  }

  function selectWork(id) {
    const w = works.find(work => work.id === id);
    if (!w) return;
    const v = bySku(w.sku);
    if (!v) return;
    state.work = w; state.handle = w.handle; state.variant = v;
    syncSelection();
    $('mda-buy').scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',block:'start'});
    $('mda-color').focus({preventScroll:true});
  }

  root.addEventListener('click', event => {
    const work = event.target.closest('[data-work-id]');
    if (work) selectWork(Number(work.dataset.workId));
    const filter = event.target.closest('[data-filter]');
    if (filter) renderCards(filter.dataset.filter);
    const tab = event.target.closest('[data-product]');
    if (tab && tab.dataset.product !== state.handle) {
      state.handle = tab.dataset.product;
      const p = product();
      state.variant = p.variants.find(v => v.available) || p.variants[0];
      state.work = works.find(w => w.sku === state.variant.sku) || null;
      syncSelection();
    }
  });
  $('mda-color').addEventListener('change', e => {
    state.variant = product().variants.find(v => String(v.id) === e.target.value);
    state.work = works.find(w => w.sku === state.variant.sku) || null;
    syncSelection();
  });
  $('mda-pattern').addEventListener('change', e => {
    const chosen = e.target.value;
    const currentColor = getColor(state.variant);
    const variants = product().variants.filter(v => getPattern(v) === chosen);
    state.variant = variants.find(v => getColor(v) === currentColor && v.available) || variants.find(v => v.available) || variants[0];
    state.work = works.find(w => w.sku === state.variant.sku) || null;
    syncSelection();
  });
  units.max = '200';
  units.addEventListener('input', updatePrice);
  $('mda-minus').addEventListener('click', () => {units.value = Math.max(1, Number(units.value)-1);updatePrice();});
  $('mda-plus').addEventListener('click', () => {units.value = Math.min(200, Number(units.value)+1);updatePrice();});
  form.addEventListener('submit', event => {
    updatePrice();
    if (add.disabled) {event.preventDefault();event.stopImmediatePropagation();return;}
    message.textContent = 'カートに追加しています…';
  }, true);
  form.addEventListener('cart:error', event => {
    message.textContent = event.detail?.error || '追加できませんでした。長さや在庫をご確認ください。';
  });
  form.addEventListener('variant:add', () => {message.textContent = 'カートに追加しました。';});
  const patternForm = $('mda-pattern-cart-form');
  patternForm.addEventListener('submit', event => {
    if ($('mda-pattern-add').disabled || $('mda-pattern-cross-sell').hidden) {
      event.preventDefault(); event.stopImmediatePropagation(); return;
    }
    $('mda-pattern-message').textContent = '型紙をカートに追加しています…';
  }, true);
  patternForm.addEventListener('cart:error', event => {
    $('mda-pattern-message').textContent = event.detail?.error || '型紙を追加できませんでした。商品ページでご確認ください。';
  });
  patternForm.addEventListener('variant:add', () => { $('mda-pattern-message').textContent = '型紙をカートに追加しました。'; });
  renderCards();
  syncSelection();
  // Preview-only fallback; native Shopify product-form remains the live submission owner.
  if (!window.Shopify) {
    form.action = 'https://kijimaru.jp/cart/add';
    patternForm.action = 'https://kijimaru.jp/cart/add';
    root.querySelectorAll('a[href^="/"]').forEach(a => { a.href = new URL(a.getAttribute('href'), 'https://kijimaru.jp').href; });
  }
})();

// Shared September review-date treatment, limited to this page.
(() => {
  const carouselSelector = '#mda-adult-lp .jdgm-cards-carousel';

  const formatDate = (value) => {
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return '';

    const parts = new Intl.DateTimeFormat('ja-JP', {
      timeZone: 'Asia/Tokyo',
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
    }).formatToParts(date);
    const part = (type) => parts.find((item) => item.type === type)?.value || '';
    return `${part('year')}/${part('month')}/${part('day')}`;
  };

  const addReviewDates = (carousel) => {
    const blockId = carousel.dataset.jdgmBlockId;
    const reviews = window.jdgmCarouselMode?.[blockId]?.reviews;
    if (!Array.isArray(reviews) || reviews.length === 0) return false;

    const reviewsById = new Map(
      reviews.map((review) => [String(review.uuid || review.id || ''), review]),
    );
    let datedCards = 0;

    carousel.querySelectorAll('.jdgm-card[data-review-id]').forEach((card) => {
      const cardIndex = Number.parseInt(card.dataset.cardIndex || '', 10);
      const review = reviewsById.get(card.dataset.reviewId)
        || (Number.isNaN(cardIndex) ? undefined : reviews[cardIndex]);
      const rawDate = review?.created_at || review?.published_at || review?.updated_at;
      const displayDate = formatDate(rawDate);
      if (!displayDate) return;

      let dateElement = card.querySelector('.jdgm-review-date');
      if (!dateElement) {
        dateElement = document.createElement('time');
        dateElement.className = 'jdgm-review-date';
        const reviewer = card.querySelector('.jdgm-reviewer-info');
        const ratingSection = card.querySelector('.jdgm-rating-section');
        if (reviewer) reviewer.after(dateElement);
        else ratingSection?.appendChild(dateElement);
      }

      dateElement.dateTime = String(rawDate).slice(0, 10);
      if (dateElement.textContent !== displayDate) dateElement.textContent = displayDate;
      datedCards += 1;
    });

    if (datedCards > 0) carousel.dataset.reviewDatesReady = 'true';
    return datedCards > 0;
  };

  const scan = () => {
    document.querySelectorAll(carouselSelector).forEach(addReviewDates);
  };

  const start = () => {
    scan();
    const observer = new MutationObserver(scan);
    observer.observe(document.documentElement, { childList: true, subtree: true });
    [300, 800, 1800, 4000, 8000].forEach((delay) => {
      window.setTimeout(scan, delay);
    });
    window.setTimeout(() => observer.disconnect(), 12000);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();

(() => {
 const init = () => {
  const section=document.querySelector('#mda-reviews');
  const track=section?.querySelector('.mda-review-track');
  if(!track)return;
  section.querySelectorAll('[data-review-step]').forEach(button=>button.addEventListener('click',()=>{
   const card=track.querySelector('.mda-review-slide');
   const step=card.getBoundingClientRect().width+parseFloat(getComputedStyle(track).columnGap||'0');
   track.scrollBy({left:Number(button.dataset.reviewStep)*step,behavior:'smooth'});
  }));
 };
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
})();
